import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';

function FireSafety({
  getFireSafetyList,
  fireSafetyList,
  getFireSafetyCalculation,
  fireSafetyCalculation,
  newOtherFeesId,
  updateCalculationFireSafety,
  ordinanceRevisionId,
}) {
  useEffect(() => {
    getFireSafetyList({
      ordinance_revision_id: ordinanceRevisionId,
    });

    if (newOtherFeesId) {
      getFireSafetyCalculation(newOtherFeesId);
    }
  }, [newOtherFeesId, ordinanceRevisionId]);

  const handleChange = (e) => {
    const { value } = e.target;
    const payload = { code: value };

    updateCalculationFireSafety(newOtherFeesId, payload, () => {
      getFireSafetyCalculation(newOtherFeesId);
    });
  };
  

  const checkIsChecked = (code) => {
    if (_.isEmpty(fireSafetyCalculation)) return false;
    const newArr = fireSafetyCalculation.map((i) => {
      const { attributes, ...rest } = i;
      return { ...attributes, ...rest };
    });
    const dataByCode = newArr.find((x) => x.code === code);
    if (!dataByCode || !dataByCode.is_exempted) return false;
    return true;
  };

  return (
    <div className="card p-0">
      <div className="card-content-listing">
        <div className="container-fluid">
          <div className="row d-flex justify-content-center">
            <div className="col-6 text-center">
              <h3>Fire Safety Calculation</h3>
            </div>
          </div>
          <div className="table-responsive mt-2">
            <table className="table table-borderless">
              <thead>
                <tr>
                  <th scope="col" className="px-1">
                    Fire Safety Inspection Fees
                  </th>
                  <th scope="col" className="px-1">
                    <div className="w-100 text-center">Included</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {!_.isEmpty(fireSafetyList) ? (
                  <React.Fragment>
                    {fireSafetyList.map((item) => (
                      <tr className="top-border" key={item.code}>
                        <td className="font-weight-bold py-3">
                          {item.description}
                        </td>
                        <td className="py-3 d-flex justify-content-center align-items-center">
                          <input
                            type="checkbox"
                            value={item.code}
                            onChange={handleChange}
                            checked={checkIsChecked(item.code)}
                          />
                        </td>
                      </tr>
                    ))}
                  </React.Fragment>
                ) : (
                  <tr />
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

FireSafety.propTypes = {
  getFireSafetyList: PropTypes.instanceOf(Function).isRequired,
  fireSafetyList: PropTypes.instanceOf(Object).isRequired,
  getFireSafetyCalculation: PropTypes.instanceOf(Function).isRequired,
  fireSafetyCalculation: PropTypes.instanceOf(Array).isRequired,
  updateCalculationFireSafety: PropTypes.instanceOf(Function).isRequired,
  newOtherFeesId: PropTypes.string.isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  fireSafetyList: _.get(api, `${c.GET_FIRE_SAFETY_LIST}.res.fees`) || [],
  newOtherFeesId: _.get(match, 'params.newOtherFeesId') || '',
  fireSafetyCalculation:
    _.get(api, `${c.GET_FIRE_SAFETY_CALCULATION}.list`) || [],
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(FireSafety);
